// Számla-státusz badge — a jel a KÖZÖS badge-katalógusból (`domain-badge.tsx`, `invoiceStatus`). A legacy CRM
// InvoiceStatusEnum inline-RGB színkódját szemantikus tokenre fordítja (Heroicons ikon-standard):
//   • draft     → muted   + dokumentum          • issued    → warning + repülő (kiállítva)
//   • paid      → success + pipa-kör            • overdue   → danger  + figyelmeztető háromszög
//   • cancelled → muted   + kereszt-kör (void)  • storno    → danger  + vissza-nyíl
//   • ismeretlen → muted  + kör-pötty
import { DomainBadge } from '@/components/shared/domain-badge';

export interface InvoiceStatusBadgeProps {
  /** A nyers státusz-string (a jel forrása). */
  status: string;
  /** A megjelenített (lokalizált) címke — a hívó adja `t('invoices.statusLabel.…')`-ből. */
  label: string;
  className?: string;
}

export function InvoiceStatusBadge({
  status,
  label,
  className,
}: InvoiceStatusBadgeProps): JSX.Element {
  return <DomainBadge kind="invoiceStatus" value={status} label={label} className={className} />;
}
